import React, { useEffect, useRef, useState } from "react";
import { Card } from '../../pages/Theme';
import { staticFiles } from '../../components/Helpers/Static';
import MarkDownContent from '../../pages/Journal/MarkDownContent';
const CROSS_GRAY_ICON = staticFiles.cross;

const ModalTermsAndPolicy = ({ showPolicyModal, setShowPolicyModal, PolicyContent }) => {
    const showHideModal = showPolicyModal
        ? 'block'
        : 'hidden'
    return (
        <div className={showHideModal} >
            <div className="fixed inset-0 modelIndex flex items-center justify-center bg-black bg-opacity-50 px-4 py-6">
                <div className={`relative cardBackgroundColor rounded-xl shadow-md p-4 max-w-full max-h-screen overflow-auto top-2 bottom-2 right-2 left-2 w-10/12`}>
                    <div className="flex gap-2 items-center justify-between">
                        <p className="font-semibold blackColor">{PolicyContent?.header}</p>
                        <button
                            onClick={setShowPolicyModal}
                            className="text-gray-600 hover:text-black text-xl font-bold"
                        >&times;
                        </button>
                    </div>
                    <MarkDownContent htmlContent={PolicyContent?.content} className={true} />
                </div>
            </div>
        </div>

    )
}

export default ModalTermsAndPolicy